import _ from 'lodash';

export default class VirtualDomIndex {
  name: string;
  index_func: any;
  elements_by_index_value: object;

  constructor(name, index_func) {
    this.name = name;
    this.index_func = index_func;

    this.elements_by_index_value = {};
  }

  addElement(element) {
    let indexValues = this.index_func(element);
    if (!_.isArray(indexValues)) {
      indexValues = [indexValues];
    }
    for (const indexValue of indexValues) {
      if (indexValue in this.elements_by_index_value) {
        this.elements_by_index_value[indexValue].push(element);
      } else {
        this.elements_by_index_value[indexValue] = [element];
      }
    }
  }

  getElementsForIndexValue(indexValue) {
    return _.get(this.elements_by_index_value, indexValue, []);
  }
}
